import { createSlice } from '@reduxjs/toolkit';
import { propOr, uniq, without } from 'ramda';

const initialState = {};

export const submitFormDialog = createSlice({
	name: 'submitFormDialog',
	initialState,
	reducers: {
		setErrors: (state, { payload }) => ({
			...state,
			[payload.page]: payload.errors,
		}),
		addSingleErrorByPageAndId: (state, { payload }) => {
			const originalErrors = propOr([], payload.page)(state);
			const updatedErrors = uniq([...originalErrors, ...payload.errors]);

			return {
				...state,
				[payload.page]: updatedErrors,
			};
		},
		removeErrorByPageAndId: (state, { payload }) => {
			const originalErrors = propOr([], payload.page)(state);

			return {
				...state,
				[payload.page]: without([payload.id], originalErrors),
			};
		},
		resetErrorsByPage: (state, { payload }) => ({
			...state,
			[payload.page]: [],
		}),
		resetErrorsAllPages: () => ({
			...initialState,
		}),
	},
});

export default submitFormDialog.reducer;
export const REDUCER_NAME = submitFormDialog.name;

export const { setErrors, resetErrorsByPage, resetErrorsAllPages, removeErrorByPageAndId, addSingleErrorByPageAndId } =
	submitFormDialog.actions;
